import { GeneralWebAnalyticsData, VideoWebAnalyticsData } from "../types";

class AnalyticsService {
    async sendGeneralData(
        data: GeneralWebAnalyticsData
    ) {

        const headers = {
            "content-type": "application/json",
        }

        fetch(`${process.env.REACT_APP_MEDIA_SERVICE_ENDPOINT}/userActivity`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: headers,
            keepalive: true,
        });
    }

    async sendVideoData(
        data: VideoWebAnalyticsData,
        sessionToken: string | null = null,
        clientId: string | null = null
    ) {
        if (sessionToken) {
            const headers = {
                "content-type": "application/json",
                Authorization: sessionToken ?? "",
            }

            fetch(`${process.env.REACT_APP_MEDIA_SERVICE_ENDPOINT}/analytics`, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: headers,
                keepalive: true,
            });
        } else {
            const headers = {
                "content-type": "application/json",
            }

            fetch(`${process.env.REACT_APP_MEDIA_SERVICE_ENDPOINT}/analytics-anon`, {
                method: 'POST',
                body: JSON.stringify({...data, clientId}),
                headers: headers,
                keepalive: true,
            });
        }
    }
}

export const analyticsService = new AnalyticsService();